import { render, staticRenderFns } from "./DataFetcher.vue?vue&type=template&id=45a85163&"
import script from "./DataFetcher.vue?vue&type=script&lang=js&"
export * from "./DataFetcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports